import { render, staticRenderFns } from "./ResponsiveImage.vue?vue&type=template&id=e8a71ce6&scoped=true&"
import script from "./ResponsiveImage.vue?vue&type=script&lang=ts&"
export * from "./ResponsiveImage.vue?vue&type=script&lang=ts&"
import style0 from "./ResponsiveImage.vue?vue&type=style&index=0&id=e8a71ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a71ce6",
  null
  
)

export default component.exports